const ACRONYMS = new Set([
  'VAT',
  'BP',
  'ID',
  'API',
  'OTP',
  'PAN',
  'IBAN',
  'SWIFT',
  'BIN',
  'URL',
  'PSP',
  'USD',
  'ZWG',
  'ZWL',
  'ZAR',
  'GBP',
  'EUR',
  'B2B',
  'B2C',
  'P2P',
  'STAN',
  'RRN',
  'ISO',
  'JWT',
  'KYC',
]);

export function humaniseId(value: string | null | undefined): string {
  if (!value) return '—';

  const words = value.split('_').filter(Boolean);
  if (!words.length) return value;

  const rendered = words.map((word, index) => {
    if (ACRONYMS.has(word.toUpperCase())) return word.toUpperCase();

    const lower = word.toLowerCase();
    return index === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
  });

  return rendered.join(' ');
}
